import { render } from "./CierreJrvStreamlined.vue?vue&type=template&id=dbff8926&scoped=true"
import script from "./CierreJrvStreamlined.vue?vue&type=script&lang=ts"
export * from "./CierreJrvStreamlined.vue?vue&type=script&lang=ts"

import "./CierreJrvStreamlined.vue?vue&type=style&index=0&id=dbff8926&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dbff8926"

export default script